import React from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getMisoUserMapping } from 'api/pgads.js'
import CommonScreen from './CommonScreen'

const MisoUsersMapping = _ => {
  return (
    <CommonScreen
      title="MISO User Mapping"
      header={MisoUserMappingHeaders}
      retrieveTask={getMisoUserMapping}
      altBy={d => d.misoUser}
      autoRetrieve
      sortOptions={MisoUserMappingHeaders}
      widthOffset={50}
      insertCompHeight={0}
      onInsertEvent={_ => false}
      withoutModify
      withDelete={false}
      allowInsert={false}
    />
  )
}

export default MisoUsersMapping
const MisoUserMappingHeaders = [
  strCol({
    ident: 'misoUser',
    display: 'MisoUser',
    isKey: true,
    sortOrder: 'asc',
    width: 450,
  }),
  strCol({ ident: 'gadsUser', display: 'GadsUser', isKey: true, width: 250 }),
  modifierCol,
  modifiedDateCol,
]
